import moment from 'moment'

import {getDefaultTruckSize, isMultipleTruck, TruckConfiguration} from '../../../../fields'
import {LoadSpacingConfiguration, LoadSpacingForm} from '../../../../fields/loadSpacing/types'
import {OrderDto} from '../../../types'
import {getOrderTruckMaxLoad} from '../trucks/trucks.utils'
import {CreateFormInput} from '../types'

export const buildLoadSpacingForm = ({
  order,
  configuration: {loadSpacing: configuration, trucks: trucksConfiguration}
}: CreateFormInput<LoadSpacingConfiguration & TruckConfiguration>): LoadSpacingForm => {
  if (!configuration.isEnabled) {
    return {
      spacingOrFlowRate: undefined,
      timeOnJobSite: undefined
    }
  }
  const schedule = order.schedules[0]
  const orderTimeOnJobSite = convertPeriodInformation(schedule.timeOnJobSite)
  const orderLoadSpace = convertPeriodInformation(schedule.arrivalSpacing)
  const orderFlowRate = schedule.quantityPerHour

  const truckMaxLoad = getOrderTruckMaxLoad(order) || getDefaultTruckSize(trucksConfiguration)

  const timeOnJobSite = orderTimeOnJobSite
    ? {time: orderTimeOnJobSite, timeUom: configuration.timeOnJobSite!.uom}
    : undefined
  const loadSpace = orderLoadSpace
    ? ({
        type: 'loadSpace',
        loadSpace: orderLoadSpace,
        loadSpaceUom: configuration.loadSpace!.uom
      } as LoadSpacingForm['spacingOrFlowRate'])
    : undefined
  const flowRate = orderFlowRate
    ? ({
        type: 'flowRate',
        flowRate: orderFlowRate,
        flowRateUom: configuration.flowRate!.uom
      } as LoadSpacingForm['spacingOrFlowRate'])
    : undefined

  return {
    spacingOrFlowRate: flowRate ?? loadSpace,
    // we are using timeOnJobSite value only in case it was not auto-calculated in SAP
    timeOnJobSite: !isTimeOnJobSiteAutoCalculatedInSAP(order, truckMaxLoad)
      ? timeOnJobSite
      : undefined
  }
}

// TODO: move to some options? common?
const timeOnJobSiteAutoCalculationCountries = ['DE', 'BE', 'NL']
const isTimeOnJobSiteAutoCalculatedInSAP = (order: OrderDto, defaultTruckSize: number) => {
  if (!timeOnJobSiteAutoCalculationCountries.includes(order.orgUnitCountryId)) {
    return false
  }

  return isMultipleTruck(order.lineItems[0].quantity, defaultTruckSize)
}

// TODO: move to utils?
const convertPeriodInformation = (rawValue: moment.DurationInputArg1) =>
  Math.round(moment.duration(rawValue).asMinutes())
